module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_11_Griffith-Uni.669cb534ec502ca3caa06d2f6efb0532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_11_Griffith-Uni.png
// module id = 773
// module chunks = 0